import { LOCATION_INITIALIZED } from '@angular/common';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';

import { AppSettingsService, IAppSettings } from './app-settings.service';
import { environment } from "@env/environment";

export function preInitServiceFactory(	
	initService: PreInitService,
	injector: Injector,
) {
	return () =>
		new Promise(resolve =>
			injector
				.get(LOCATION_INITIALIZED, Promise.resolve(undefined))
				.then(() => resolve(initService.onInit()))
		);
}

@Injectable()
export class PreInitService {
	constructor(
		private httpBackend: HttpBackend,
		private appSettingsService: AppSettingsService,
	) { }

	onInit(): Promise<boolean> {

		const http = new HttpClient(this.httpBackend);
		const settingsFile = `/assets/app-settings.${environment.name}.json`;

		return http.get<IAppSettings>(settingsFile)
			.toPromise()
			.then(config => this.appSettingsService.setSettings(config))
			.then(_ => true)
			.catch(error => {
				console.error('Error loading application configuration', error);
				return Promise.resolve(false);
			});
	}
}